import React from 'react';
import { Plus, Minus } from 'lucide-react';

const PLACEHOLDER = 'e.g. She always starts with a POV hook, uses trending audio, never shows her face, posts 3x/week. Her audience loves budget hacks and relatable family moments. Avoids brand-heavy content.';

export const ContextField = ({ value, onChange, open, setOpen, saved }) => (
  <div data-testid="creator-ideation-context">
    <button type="button" onClick={() => setOpen(!open)} className="text-xs font-semibold inline-flex items-center gap-1 text-[#FF451A] hover:text-[#E63E17] transition-colors" data-testid="creator-ideation-context-toggle">
      {open ? <Minus size={12} /> : <Plus size={12} />} {open ? 'Hide creator context' : value ? 'Edit creator context' : 'Add creator context'}
    </button>
    {open && (
      <div className="mt-2">
        <label className="text-xs font-semibold uppercase tracking-[0.08em] block mb-2 text-[#0F0F0F] dark:text-white">
          Creator Style & Context (optional){saved && <span className="ml-2 normal-case tracking-normal font-normal text-[#6B6B6B] dark:text-zinc-400">· loaded from saved profile</span>}
        </label>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={2000}
          rows={3}
          placeholder={PLACEHOLDER}
          className="w-full rounded-md px-3 py-2 text-sm bg-white dark:bg-[#1A1D24] border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white placeholder-[#A1A1AA] dark:placeholder-zinc-500 focus:outline-none focus:border-[#FF451A]/60 transition-colors"
          data-testid="creator-ideation-context-input"
        />
        <p className="text-[10px] text-[#6B6B6B] dark:text-zinc-400 mt-1">Saved to the creator's profile when you generate, so it loads automatically next time.</p>
      </div>
    )}
  </div>
);
